<template>
  <loading-list v-if="viewData.loadingPage"></loading-list>
  <b-container v-else-if="viewData.success">
    <b-alert show variant="success">
      <h4 class="alert-heading">Senha redefinida!</h4>
      <p v-if="this.isAdmin">
        <a href="/#/login">Clique aqui para entrar na aplicação.</a>
      </p>
      <p v-else>Acesse a APP agora com a sua nova senha</p>
      <hr />
    </b-alert>
  </b-container>
  <b-form class="form-signin" v-else>
    <img class="mb-4" src="/images/logo_veins.png" alt style="width: 19em" />
    <h1 class="h3 mb-3 font-weight-normal">Crie sua senha</h1>

    <error-container v-bind:errors="viewData.errors || []" />

    <b-form-group v-if="!viewData.success">
      <label for="inputPassword" class="sr-only">Senha Atual</label>
      <b-input
        :state="isOk('password')"
        v-model="state.oldPassword"
        type="password"
        placeholder="Informe a senha atual"
        v-on:keyup.enter="save"
        required
      />
      <b-form-invalid-feedback style="text-align:left">{{
        getError('password')
      }}</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group v-if="!viewData.success">
      <label for="inputPassword" class="sr-only">Nova Senha</label>
      <b-input
        :state="isOk('password')"
        v-model="state.password"
        type="password"
        placeholder="Defina uma senha"
        v-on:keyup.enter="save"
        required
      />
      <b-form-invalid-feedback style="text-align:left">{{
        getError('password')
      }}</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group>
      <label for="inputPassword" class="sr-only">Confirmar Nova Senha</label>
      <b-input
        :state="isOk('confirm')"
        v-model="state.confirm"
        type="password"
        placeholder="Confirmar senha"
        v-on:keyup.enter="save"
        required
      />
      <b-form-invalid-feedback style="text-align:left">{{
        getError('confirm')
      }}</b-form-invalid-feedback>
    </b-form-group>
    <button
      type="button"
      v-bind:disabled="viewData.loading"
      class="btn btn-primary btn-lg btn-block"
      v-on:click="save"
    >
      <b-icon
        v-if="viewData.loading"
        icon="three-dots"
        animation="cylon"
      ></b-icon>
      <span v-else>Entrar</span>
    </button>
  </b-form>
</template>

<script>
import { Auth } from '../vue/auth';
import { Api } from '../vue/api';
import helpers from '../vue/helpers';

const API = new Api();

export default {
  name: 'change-password',
  data: function() {
    return {
      state: {
        oldPassword: '',
        password: '',
        confirm: '',
      },
      viewData: {
        loading: false,
        errors: [],
        loadingPage: true,
        success: false,
      },
    };
  },
  computed: {
    isAdmin() {
      return this.$route.path.indexOf('admin') >= 0;
    },
    url() {
      return this.isAdmin ? '/run' : '/user/run';
    },
  },
  beforeMount: async function() {
    try {
      this.viewData.loadingPage = true;

      const result = await API.post(this.url, {
        path: '/change-password/' + this.$route.params.token,
        method: 'get',
      });
    } catch (ex) {
      this.$toast.error(helpers.getFirstError(ex));
    }

    this.viewData.loadingPage = false;
  },
  methods: {
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    async save() {
      try {
        this.viewData.loading = true;
        await API.post(this.url, {
          path: '/change-password/' + this.$route.params.token,
          method: 'post',
          data: this.state,
        });

        this.viewData.success = true;
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }

      this.viewData.loading = false;
    },
  },
  components: {},
};
</script>
